var map = {
	"./en": [
		"Kn7G",
		2
	],
	"./en.json": [
		"Kn7G",
		2
	],
	"./es": [
		"a/1Z",
		1
	],
	"./es.json": [
		"a/1Z",
		1
	],
	"./it": [
		"VdgG",
		0
	],
	"./it.json": [
		"VdgG",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "7xKO";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang lazy ^\.\/.*$
// module id = 7xKO
// module chunks = 32